import { render } from "./UserHoverTooltip.vue?vue&type=template&id=fff161d8&scoped=true"
import script from "./UserHoverTooltip.vue?vue&type=script&lang=js"
export * from "./UserHoverTooltip.vue?vue&type=script&lang=js"

import "./UserHoverTooltip.vue?vue&type=style&index=0&id=fff161d8&lang=scss&scoped=true"

import exportComponent from "/main/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fff161d8"]])

export default __exports__